import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Divider } from '@material-ui/core';
import { Toolbar, Card, Datasets } from './components';
import Groups from '../../../Group/components/GroupPage/components/Groups';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.white,
    overflow: 'hidden'
  },
  overflow: {
    overflow: 'auto',
    height: 'calc(100% - 68px)',
    paddingBottom: theme.spacing(3)
  },
  mt: {
    marginTop: theme.spacing(3)
  }
}));

const RepositoryPage = props => {
  const { onBack, onDelete, onEdit, onAdd, onAddDatasets, onRefresh, repository, sharedRepos, className, sharedGroups, onShareRepository, ...rest } = props;

  const classes = useStyles();

  const handleRefresh = (repository) => () => {
    onRefresh && onRefresh(repository);
  };

  const handleShareRepository = (isShared, classroomID) => {
    onShareRepository && onShareRepository(isShared, classroomID);
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Toolbar
        handleRefresh={handleRefresh}
        onBack={onBack}
        open={repository.open}
        repository={repository.values}
      />
      <Divider />
      <div className={classes.overflow}>
        {repository.open &&
          <React.Fragment>
            <Card
              onDelete={onDelete}
              onEdit={onEdit}
              repository={repository.values}
            />
            <Datasets
              className={classes.mt}
              handleRefresh={handleRefresh(repository.values)}
              onAdd={onAdd}
              onAddDatasets={onAddDatasets}
              repository={repository.values}
              sharedRepos={sharedRepos}
              title="Datasets"
            />
            <Groups 
              className={classes.mt}
              title="Groups"
              sharedGroups={sharedGroups}
              onShareRepository={handleShareRepository}
            />
          </React.Fragment>
        }
      </div>
    </div>
  );
};

RepositoryPage.propTypes = {
  className: PropTypes.string,
  onAdd: PropTypes.func,
  onAddDatasets: PropTypes.func,
  onBack: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  onRefresh: PropTypes.func,
  onShareRepository: PropTypes.func,
  repository: PropTypes.object,
  sharedGroups: PropTypes.array,
  sharedRepos: PropTypes.array
};

export default RepositoryPage;
